import React from 'react'
import { Field } from 'redux-form'

import { translate } from 'parking-react-common'

import { forms, ui } from '../redux'

import Panel from '../components/Panel'
import Button from '../components/Button'
import { Column } from '../components/Grid'
import form from '../components/Form'
import DatePickerInput from './DatePickerInput'
import Input from './Input'
import Switch from './Switch'
import FormContainer from './FormContainer'

const PromoCodesForm = ({ isSubmitting, isPristine, t }) => (
    <Panel title={ t('Add a new Promo Code') }>
        <FormContainer isHorizontal>
            <Field
                name="name"
                label={ t('Name') }
                placeholder={ t('Name') }
                component={ Input }
                size={ ui.SIZE.small }
                isHorizontal
            />
            <Field
                name="start_moment"
                label={ t('Start Date') }
                component={ DatePickerInput }
                size={ ui.SIZE.small }
                isHorizontal
            />
            <Field
                name="stop_moment"
                label={ t('Stop Date') }
                component={ DatePickerInput }
                size={ ui.SIZE.small }
                isHorizontal
            />
            <Field
                name="quantity"
                label={ t('Quantity') }
                placeholder={ t('Quantity') }
                component={ Input }
                size={ ui.SIZE.small }
                isHorizontal
            />
            <Field
                name="discount"
                label={ `${t('Discount')} %` }
                placeholder={ t('Discount') }
                component={ Input }
                size={ ui.SIZE.small }
                isHorizontal
            />
            <Field
                name="enabled"
                label={ t('Enabled') }
                placeholder={ t('Enabled') }
                component={ Switch }
                isHorizontal
            />
            <Column span={ 3 } />
            <Column span={ 3 }>
                <Button
                    type="submit"
                    label={ t('Add') }
                    size={ ui.SIZE.large }
                    intent={ ui.INTENT.primary }
                    isBlock
                    disabled={ isSubmitting || isPristine }
                />
            </Column>

        </FormContainer>
    </Panel>
)

PromoCodesForm.propTypes = forms.propTypes

export default translate()(form({ id: forms.promoCode.id })(PromoCodesForm))
